import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatNumber(num) {
  return new Intl.NumberFormat('en-IN').format(num);
}

/**
 * Format a material-quantity map { unit: qty } into a readable string e.g. "650 Thans · 40 Bales".
 * Returns the provided emptyText (default "—") when there is no material quantity recorded.
 */
export function formatMaterialMap(materialMap, emptyText = '—') {
  if (!materialMap || typeof materialMap !== 'object') return emptyText;
  const parts = Object.entries(materialMap)
    .filter(([, qty]) => qty != null && qty !== 0)
    .map(([unit, qty]) => `${formatNumber(qty)} ${unit}`);
  return parts.length ? parts.join(' \u00B7 ') : emptyText;
}

export function formatCurrency(num) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(num);
}
